import { sizes } from "@hubrise/react-components"
import styled from "styled-components"

export const StyledDetails = styled.div`
  height: 100%;
  width: 50em;
`

export const Content = styled.div`
  padding: 1em 1.5em;
  display: flex;
  flex-direction: column;
  border-radius: ${sizes.borderRadius} ${sizes.borderRadius} 0 0;
  background-color: white;
  border: 1px solid #f2f2f2;
`

export const SplitHalf = styled.div`
  display: flex;
  gap: 2rem;

  > div {
    width: calc(50% - 1rem);
  }
`
